<template>
  <BaseModal
    :name="name"
    width-class="tw-max-w-[550px]"
    @show="sendSegmentEvent"
  >
    <div>
      <div
        class="tw-flex tw-justify-center tw-rounded-t-xl tw-bg-error-500 tw-p-3"
      >
        <WarningIcon class="tw-h-6 tw-w-6 tw-text-white" />
      </div>
      <div class="tw-p-5 tw-text-center">
        <h2 class="tw-heading-2">
          <slot name="header" />
        </h2>

        <div class="tw-mt-3 tw-text-neutral-500">
          <slot name="description" />
        </div>
      </div>

      <div
        class="tw-mx-auto tw-mb-8 tw-flex tw-w-80 tw-flex-col tw-items-center tw-space-y-4"
      >
        <ProPlanCardWithPerks />

        <BaseButton color="outline-gray" @click="closeModal(name)">
          Close
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import WarningIcon from '@/assets/images/icons/warning.svg'
import BaseButton from '@/shared/components/BaseButton.vue'
import ProPlanCardWithPerks from '@/shared/components/cards/ProPlanCardWithPerks.vue'
import { useModals } from '@/shared/composables/useModals.js'
import BaseModal from '@/shared/components/BaseModal.vue'

const VALID_SEGMENT_TYPES = [
  'help_requests',
  'community',
  'monthly_session_limit',
]

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  segmentPromptType: {
    type: String,
    required: true,
  },
})

const { closeModal } = useModals()

const sendSegmentEvent = () => {
  if (!VALID_SEGMENT_TYPES.includes(props.segmentPromptType)) {
    console.error('Invalid segmentPromptType', props.segmentPromptType)
    return
  }
  window.segmentAnalytics.track('Membership upgrade modal', {
    modal_prompt: props.segmentPromptType,
  })
}
</script>
